export enum EmploymentTypeEnum {
  FullTime = 1,
  PartTime = 2
}
